import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setUsers, clearUsers } from "../../../store/actions/usersActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAllUsers = (bearerAuth) => {
  return async dispatch => {
    API.get("/api/portal/users")
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500) // anything under 500 handled in code, 500+ thrown as exception
      .then((response) => {
        if (response.status === 200) {
          let agencyArr = [];

          for (let user of response.body) {
            if (!agencyArr.includes(user.agency) && user.agency) {
              agencyArr.push(user.agency);
            }
          }

          dispatch(setUsers(response.body, agencyArr))
        } else if (response.status === 401) {
          dispatch(clearUsers);
          dispatch(authLogout);
        } else {
          dispatch(clearUsers);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'User Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearUsers);
      })
  }
}